// extracted by mini-css-extract-plugin
export default {"container":"Price__container___uvF9L","taxSuffix":"Price__taxSuffix___cCWRi","value":"Price__value___NT0Mn"};